// extracted by mini-css-extract-plugin
export default {"gridContainer":"gridContainer___DtoUD","truckCard":"truckCard___qi8E8","truckCardItem":"truckCardItem___kEVEQ"};